import React from "react";
import {Button, Card, CardBody, CardHeader, Col, Form, FormSelect, Row } from "shards-react";
import {actions as AppActions} from "../../_stores/app.store";
import { FcPlus } from "react-icons/fc";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import WardService from "../../services/manageWard.service";
import SupplierService from "../../services/supplier.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

const perPage = 10;
const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

class WardManagement extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      selectedSupplier: "",
      supplierList: [],
      file: null,
      wardList: []
    };

    this.getTableData = this.getTableData.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.aggridRef = React.createRef();
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  componentDidMount() {
    this.fetchSuppliers();
  }

  fetchSuppliers() {
    AppActions.setLoading(true);
    SupplierService.getAll().then((response) => {
      AppActions.setLoading(false);
      if (response.data && response.data.data && response.data.data.length)
        this.setState({
          supplierList: response.data.data,
        });
    });
  }

  readFile(e) {
    const { target } = e;
    let file = null;

    if (target.files && target.files.length > 0) {
      file = target.files[0];
      this.setState({ file: file });
    }
  }

  handleFileUpload() {
    const { file } = this.state;
    var data = {
      supplierCode: this.state.selectedSupplier,
      file: file
    }
    AppActions.setLoading(true);
    WardService.saveSupplierWardDetails(data)
      .then(async (response) => {
        AppActions.setLoading(false);
        //console.log('handleFileUpload.response', response);
        if (response.data) { // check for success
          var notify_message = ({
            type: "success",
            message: "File has been uploaded successfully."
          });
        } else {
          if (response.data.err.message) { // fields error
            var notify_message = ({
              type: "error",
              message: response.data.err.message
            });
          }
          else { // mongo error
            var notify_message = ({
              type: "error",
              message: "File has been Already uploaded"
            });
          }
        }
        this.setState({ file: null });
        this.notify(notify_message.type, notify_message.message);
      });
  }

  getTableData = () => {
    AppActions.setLoading(true);
    console.log('getTableData');
    this.setState({ wardList: [] });

    if(this.state.selectedSupplier){
       WardService.getDestinationDtlsBySupplierCode(this.state.selectedSupplier).then((response) => {
        AppActions.setLoading(false);
        console.log(response.data.length);
        if (response.data && response.data.length > 0) {
          const supplierDestinationDtls = JSON.parse(JSON.stringify(response.data));
          this.setState({ 
            wardList: supplierDestinationDtls
          });
        }
      }); 
    }
  }

  saveTableData = () => {
    AppActions.setLoading(true);
    const { wardList } = this.state;
    const newArray = [];
    wardList.forEach((obj) => {
      if (obj.destination_name && obj.destination_name.length > 0) {
        const pushObj = { 
          "destinationCode":obj.destination_code,
          "destinationName":obj.destination_name,
          "SupplierIssInfoCode":obj.SupplierIssInfoCode,
          "SupplierIssInfoName":obj.SupplierIssInfoName,
          "sourceHospitalCode":obj.sourceHospitalCode 
        }
        newArray.push(pushObj);
      }
    });
    console.log('saveTableData.newArray', newArray);
    if (newArray.length > 0) {
      const request = {
        supplierCode: this.state.selectedSupplier,
	      destinationJsonData: newArray
      };
      WardService.updateSupplierWardDetails(JSON.stringify(request)).then((response) => {
        AppActions.setLoading(false);
        if (response.data) {
          var notify_message = {
            type: "success",
            message: "Destination details updated successfully.",
          };
          this.notify(notify_message.type, notify_message.message);
        } else {
          var notify_message = {
            type: "error",
            message: response.data.message,
          };
          this.notify(notify_message.type, notify_message.message);
        }
      });
    } else {
      AppActions.setLoading(false);
      var notify_message = {
        type: "error",
        message: "No Data to save",
      };
      this.notify(notify_message.type, notify_message.message);
    }
  }

  notify(type, message) {
		toast(message, {
			position: "top-right",
			autoClose: 5000,
			hideProgressBar: true,
			closeOnClick: true,
			type: type,
		});
	}

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  exportToExcel() {
    const { wardList } = this.state;
    const sheetdata = [];
    sheetdata.push(["Destination Code", "Destination Name", "Supplier Info Code", "Supplier Info Name", "Hospital Code", "Source Hospital Code"]);
    for (let i = 0; i < wardList.length; i++) {
      const conItem = wardList[i];
      sheetdata.push([conItem.destination_code, conItem.destination_name, conItem.supplierIssInfoCode, conItem.supplierIssInfoName, conItem.hospitalCode, conItem.sourceHospitalCode]);
    }
    this.prepWorkbookFromJson(sheetdata,wardList[0].hospitalCode);
  }

  prepWorkbookFromJson(sheetdata,hospitalcode) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer,hospitalcode);
  }

  createUrlFromBlob(bufferData,hospitalcode) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFile(objurl, hospitalcode + "_destinationmaster");
    URL.revokeObjectURL(objurl);
  }

  downloadFile(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

    render(){
        const {
          selectedSupplier,
          supplierList
        } = this.state;
        const { wardList } = this.state;
        const columnDefs = [
          {headerName: "Destination Code", field: "destination_code" },
          {headerName: "Destination Name", field: "destination_name", editable: true,  width:"200" },
          {headerName: "Supplier Info Code", field: "supplierIssInfoCode" },
          {headerName: "Supplier Info Name", field: "supplierIssInfoName", width:"200" },
          {headerName: "Hospital Code", field: "hospitalCode" },
          {headerName: "Source Hospital Code", field: "sourceHospitalCode", editable: true,   }
        ]
        return(
          <>
            <div className="border-bottom">
              <Row className="mb-4">
                <Col md="12" className="mt-3">
                  <h5 className="m-0">Manage Wards</h5>
                </Col>
              </Row>
              <Row className="mb-4">
                <Col md="12" className="">
                  <Row>
                    <Col md="4" className="flx-dir-col">
                      <label className="mb-0">Select Hospital</label>
                      <FormSelect
                        id="supplier-select"
                        onChange={(evt) =>
                          this.setState({
                            selectedSupplier: evt.target.value,
                          })
                        }
                        value={selectedSupplier}
                      >
                        <option value={0}>Select</option>
                        {supplierList.map((supplier) => (
                          <option key={supplier.supplierName} value={supplier.supplierCode}>
                            {supplier.supplierName}-{supplier.supplierCode}
                          </option>
                        ))}
                      </FormSelect>
                    </Col>
                    {selectedSupplier && ( 
                      <Col md="3" className="mt-4">
                        <button
                          className="btn btn-primary mt-auto"
                          onClick={this.getTableData}
                        >
                          Get Data
                        </button>
                      </Col>
                    )}
                    {selectedSupplier && wardList.length > 0 && (
                      <Col md="3" className="mt-4">
                        <button className="btn btn-primary mt-auto" onClick={this.exportToExcel}>
                          Download Data
                        </button>
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
              {selectedSupplier && ( 
              <Row className="mb-4">
                <Col md="12" className="mb-0" >
                  <Form>
                    <Row form>
                      <Col className="form-group">
                        <Row className="form-group-row">
                          <Col className="form-label" md="4">
                            <label htmlFor="">Upload Ward File</label>
                          </Col>
                          <Col className="form-field" md="4">
                            <div className="file-ctrl-wrap">
                              <input
                                type="file"
                                className="file-input"
                                id="file"
                                name="file"
                                placeholder="Upload your excel file"
                                onChange={this.readFile.bind(this)}
                              />
                            </div>
                          </Col>
                          <Col className="form-button" md="4">
                            <Button variant="primary" className="ml-3 btn btn-success" onClick={this.handleFileUpload}>
                              <FcPlus /> Upload Ward File
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
              )}
            </div>
            <div className="ag-theme-balham" style={{ height: '300px', width: '100%' }}>
              <Row className="">
                <Col md="3">
                  <div className="example-header">
                    Page Size: &nbsp;
                    <select onChange={this.onPageSizeChanged} id="page-size">
                      <option value="1" selected={true}>
                        10
                      </option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                </Col>
                <Col md="6"></Col>                
                <Col md="3" className="mb-2 mt-2">
                  {selectedSupplier && wardList.length > 0 && ( 
                  <div>
                    <button className="btn btn-primary mt-auto"
                      onClick={this.saveTableData}>
                      Save Data
                    </button>                    
                  </div>
                  )}
                </Col>
              </Row>
              <AgGridReact
                ref={this.aggridRef}
                pagination={true}
                rowHeight={30}
                paginationPageSize={perPage}
                columnDefs={columnDefs}
                rowData={wardList}
              >
              </AgGridReact>
            </div>
          </>
        );
    }
}

export default WardManagement;